<script>
	module.exports = {
		props: {
			video: {
				default: ''
			},
			auth: {
				default: false
			},
			eventData: {
				default: undefined
			}
		},
		computed: {
			videoId() {
				let video = this.video;
				let id = '';
				if (video && video.video_id) {
					id = video.video_id;
				}
				return id;
			},
			contentBefore() {
				let video = this.video;
				let before = null;
				if (video && video.content_before) {
					before = video.content_before;
				}
				return before;
			},
			contentAfter() {
				let video = this.video;
				let after = null;
				if (video && video.content_after) {
					after = video.content_after;
				}
				return after;
			}
		},
		components: {
			'vimeo-player': require('components/vimeo-player.vue').default
		}
	};
</script>
<style lang="scss">
	.video-content {
		iframe.vimeo-player {
			width: 100%;
			height: auto;
			min-height: 20rem;
		}
	}
</style>
<template>
	<div class="video-content">
		<div v-html="contentBefore"></div>
		<vimeo-player
			v-if="videoId"
			:video-id="videoId"
			:auth="auth"
			:event-data="eventData"
			class="print-hidden">
		</vimeo-player>
		<div v-html="contentAfter"></div>
	</div>
</template>
